import { Box, Button, Divider, Typography } from '@mui/material';
import { CommonDialog, CommonDialogHeader } from '../../Dialog';
import { IOrderError } from '../../../types/api/response/ordererrorsresponse';

interface Props {
  error: IOrderError | null;
  isOpen: boolean;
  onClose: () => void;
}

const Field = ({
  label,
  value,
  mono = false,
}: {
  label: string;
  value: string | number | null | undefined;
  mono?: boolean;
}) => (
  <Box py={1.5}>
    <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.5}>
      {label}
    </Typography>
    <Typography
      variant="body2"
      sx={{
        wordBreak: 'break-all',
        whiteSpace: 'pre-wrap',
        fontFamily: mono ? 'monospace' : 'inherit',
        fontSize: mono ? 12 : 'inherit',
        color: value == null ? 'text.disabled' : 'inherit',
      }}
    >
      {value ?? 'not assigned'}
    </Typography>
  </Box>
);

export const OrderErrorDetailDialog = ({ error, isOpen, onClose }: Props) => {
  if (!error) return null;

  return (
    <CommonDialog
      isOpen={isOpen}
      header={<CommonDialogHeader title="Order Error Detail" onClose={onClose} />}
      body={
        <Box mt={1} sx={{ maxHeight: '65vh', overflowY: 'auto', pr: 0.5 }}>
          <Field
            label="Timestamp"
            value={error.created_at ? new Date(error.created_at).toLocaleString() : null}
          />
          <Divider />
          <Field label="Order Number (ORD-)" value={error.order_number} />
          <Divider />
          <Field label="DS Order Number (SO-)" value={error.ds_order_number} />
          <Divider />
          <Field label="Cin7 Sale ID" value={error.ds_sale_id} />
          <Divider />
          <Field label="Customer Phone" value={error.user_phone} />
          <Divider />
          <Field label="Stage" value={error.stage} />
          <Divider />
          <Field label="Dependency" value={error.dependency} />
          <Divider />
          <Field label="Error Code" value={error.error_code} />
          <Divider />
          <Field label="Dependency Status" value={error.dependency_status} />
          <Divider />
          <Field label="Message" value={error.message} />
          {error.dependency_response && (
            <>
              <Divider />
              <Field label="Dependency Response" value={error.dependency_response} mono />
            </>
          )}
          {error.dependency_request && (
            <>
              <Divider />
              <Field label="Dependency Request" value={error.dependency_request} mono />
            </>
          )}
          <Divider />
          <Field label="Correlation ID" value={error.correlation_id} mono />
          {error.stack_trace && (
            <>
              <Divider />
              <Field label="Stack Trace" value={error.stack_trace} mono />
            </>
          )}
        </Box>
      }
      footer={
        <Box display="flex" justifyContent="flex-end" mt={1}>
          <Button variant="outlined" size="small" onClick={onClose}>
            Close
          </Button>
        </Box>
      }
    />
  );
};
